<template>
  <v-container fluid pa-0 ma-0>
    <!--FAILED-->
    <v-flex v-if="isFailed" xs12 dark class="text-xs-center dropbox-error">
      <blockquote dark class="blockquote error text-xs-center elevation-12 white--text">
        <v-icon x-large>warning</v-icon>

        <h2>Upload failed.</h2>
        <p>
          <a href="javascript:void(0)" class="white--text" @click="reset()">
            Try again
          </a>
        </p>
        <p>{{ uploadError }}</p>
        <ul v-if="unsupportedFiles.length > 0">
          <li
            v-for="(file, index) in unsupportedFiles"
            :key="index"
            style="list-style-type: none"
            class="font-weight-bold"
            bold
          >
            {{ file }}
          </li>
        </ul>
      </blockquote>
    </v-flex>
    <!--UPLOAD-->
    <v-flex v-else xs12 class="dropbox">
      <form v-show="isOnUploadPage" enctype="multipart/form-data" novalidate>
        <v-flex xs12>
          <input
            type="file"
            multiple
            accept="image/jpeg, application/pdf"
            class="input-file"
            @change="
              filesChange($event.target.files)
              fileCount = $event.target.files.length
            "
          />
        </v-flex>
        <v-layout column align-center justify-center>
          <v-flex xs10>
            <span>Choose the type of file that you are uploading.</span>
          </v-flex>
          <v-flex v-show="isInitial || isSuccess">
            <v-flex xs6>
              <v-select
                v-model="fileType"
                :items="itemFileType"
                label="Choose File Type"
                item-text="label"
                item-value="value"
                prepend-icon="cloud_upload"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <span>
                Then drag your pdf or image file(s) here to begin
                <br />
                or click to browse
                <br />
                <p v-show="isSaving">
                  Uploading {{ fileCount }} files...
                  <v-progress-linear :indeterminate="isSaving"></v-progress-linear>
                </p>
              </span>
            </v-flex>
          </v-flex>
        </v-layout>
      </form>
    </v-flex>

    <v-flex v-if="isDownloading" xs12>
      <span>Downloading</span>
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </v-flex>

    <v-flex v-if="isDeleting" xs12>
      <span>Deleting</span>
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </v-flex>

    <!--SUCCESS-->
    <v-flex v-if="isSuccess || rows.length > 0" xs12>
      <h2 v-if="isOnUploadPage">
        Uploaded {{ rows.length }} file(s) successfully.
        <span class="info--text">
          Combined File Size Limit Remaining: {{ totalFileSize }}MB
        </span>
      </h2>
      <strong>Click a button below to download individual files.</strong>
      <v-data-table :headers="headers" :items="rows" class="elevation-1" hide-actions>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">
            <v-btn flat icon color="green" @click="downloadAttachment(props.item)">
              <v-icon>cloud_download</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-left">
            <b>{{ props.item.filename }}</b>
          </td>
          <td class="text-xs-left">{{ props.item.contentType }}</td>
          <td class="text-xs-left">{{ props.item.fileType }}</td>
          <td class="text-xs-left">{{ props.item.fileSize | sizeToMB }}</td>
          <td class="text-xs-left">
            <v-btn
              v-if="!isDeleting"
              flat
              icon
              color="red"
              @click="removeAttachment(props.item.fileGuid)"
            >
              <v-icon>cancel</v-icon>
              <v-progress-circular
                v-show="isDeleting"
                indeterminate
                color="red"
              ></v-progress-circular>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <message-alert :component="message"></message-alert>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers, mapGetters } from 'vuex'
import { mapUploadFields, mapUploadMultiRowFields } from '../store/modules/orders'
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`)
const { mapActions: mapUploadActions } = createNamespacedHelpers(`orders/uploads`)
import { httpError } from '../models/httpError'
import { bytesToSize } from '@/plugins/bytesToSize'

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3

export default {
  name: 'FileUploader',
  filters: {
    sizeToMB(args) {
      return `${bytesToSize(args, 2, 1024, 'MiB')} MB`
    }
  },
  props: {
    orderGUID: String,
    isOnUploadPage: Boolean
  },
  data() {
    return {
      fileChangeSuccess: false,
      maxAllowedFileSize: 10,
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      unsupportedFiles: [],
      itemFileType: [
        { label: 'General', value: 'general' },
        { label: 'Licence', value: 'licence' },
        { label: 'Business Card', value: 'businessCard' },
        { label: 'Bill', value: 'bill' },
        { label: 'ECC', value: 'ecc' }
      ],
      fileCount: 0,
      fileType: this.$route.params.fileType,
      files: new FormData(),
      headers: [
        {
          text: 'Download',
          align: 'left',
          sortable: false,
          value: 'true'
        },
        {
          text: 'File Name',
          align: 'left',
          sortable: true,
          value: 'filename'
        },
        {
          text: 'Content Type',
          align: 'left',
          sortable: true,
          value: 'contentType'
        },
        {
          text: 'File Type',
          align: 'left',
          sortable: true,
          value: 'fileType'
        },
        {
          text: 'File Size',
          align: 'left',
          sortable: true,
          value: 'fileSize'
        },
        {
          text: 'Remove',
          align: 'left',
          sortable: false,
          value: 'true'
        }
      ],
      isDownloading: false,
      isDeleting: false
    }
  },
  watch: {
    isDownloading(val) {
      if (val) return setTimeout(() => (this.isDownloading = false), 1000) //Added a small delay just in case of super-quick downloads.
    },
    isDeleting(val) {
      if (val) return setTimeout(() => (this.isDeleting = false), 1000)
    }
  },
  computed: {
    ...mapUploadFields(['message']),
    ...mapUploadMultiRowFields(['rows']),
    ...mapGetters('orders', ['orderID']),
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    },
    totalFileSize() {
      return this.getTotalFileSize()
    }
  },

  methods: {
    ...mapUploadActions([
      'populateUploads',
      'updateUploadsOnOrder',
      'removeRows',
      'setMessage',
      'UploadToKayako',
      'getAttachment',
      'deleteAttachment',
      'getExtension',
      'populateUploadsCustomer'
    ]),
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
      this.files = new FormData()
      this.fileCount = 0
    },
    save(someUnsupported, unsupportedFiles) {
      this.currentStatus = STATUS_SAVING
      let vm = this
      let form = { guid: vm.orderGUID, data: vm.files, fileType: vm.fileType }
      if (!vm.fileType) {
        vm.uploadError = 'File type is required'
        vm.currentStatus = STATUS_FAILED
        return
      }
      vm.updateUploadsOnOrder(form)
        .then((x) => {
          vm.uploadedFiles = [].concat(x.files)
          vm.currentStatus = STATUS_SUCCESS
          setTimeout(() => (vm.currentStatus = STATUS_INITIAL), 1000)
        })
        .catch((err) => {
          vm.uploadError = err.response || 'Upload failed'
          vm.currentStatus = STATUS_FAILED
        })
      vm.files = new FormData()
    },

    downloadAttachment(item) {
      const vm = this
      vm.isDownloading = true
      let filetoBeDownloaded = { orderID: vm.orderID, file: item }
      vm.getAttachment(filetoBeDownloaded).then((x) => {
        vm.downloadAttachment = false
        vm.$forceUpdate()
      })
    },
    getTotalFileSize() {
      let size = this.rows.reduce(
        (acc, curr) => acc + bytesToSize(curr['fileSize'], 2, 1024, 'MiB'),
        0
      )
      return parseFloat(this.maxAllowedFileSize - size).toFixed(2)
    },
    filesChange(fileList) {
      let vm = this

      if (!fileList.length) return

      const isSupportedType = (element) => element.type === 'image/jpeg' || element.type === 'application/pdf'
      const isUnSupported = (element) => element.type !== 'image/jpeg' && element.type !== 'application/pdf'

      let files = Array.from(fileList)
      const unsupportedFiles = files.filter(isUnSupported)
      const someUnsupported = unsupportedFiles.length > 0

      if (someUnsupported) {
        vm.uploadError = 'These files are not of a supported type: '
        vm.currentStatus = STATUS_FAILED
        vm.unsupportedFiles = unsupportedFiles.map((s) => s.name)
        vm.fileChangeSuccess = false
        vm.files = new FormData()
        return
      }

      vm.fileChangeSuccess = false
      vm.uploadError = null

      this.fileCount = fileList.length

      // append the files to FormData
      Array.from(Array(files.length).keys()).map((x) => {
        let fileSize = bytesToSize(files[x].size, 2, 1024, 'MiB')

        if (
          parseFloat(fileSize > this.maxAllowedFileSize) ||
          parseFloat(this.getTotalFileSize() - fileSize) < 0
        ) {
          vm.fileChangeSuccess = false
          vm.uploadError =
            'Total size of all files exceeds order combined file size limit of 10MB'
          vm.currentStatus = STATUS_FAILED
          return
        }

        vm.files.append('files', files[x], files[x].name)
        vm.fileChangeSuccess = true
      })

      // save it
      // if (vm.fileChangeSuccess)
      //   this.save(someUnsupported, Array.from(fileList).filter(isUnSupported))
      if (!vm.fileChangeSuccess) return
      this.save(false, [])
    },
    removeAttachment(fileGuid) {
      let vm = this
      //
      this.isDeleting = true

      let filetoBeDeleted = { orderID: vm.orderID, guid: fileGuid }
      this.deleteAttachment(filetoBeDeleted)
        .then((x) => {
          this.isDeleting = false
          this.reset()
          this.populateUploads(vm.orderID)
        })
        .catch((err) => {
          vm.uploadError = err.response
        })
    },
    setIcon(type) {
      if (type == 'application/pdf' || type == 'application/text') {
        return
      } else {
        return 'photo'
      }
    }
  },
  mounted() {
    this.reset()
    this.populateUploads(this.orderID)
    if (this.isOnUploadPage) {
      this.fileType = this.itemFileType[0].value
    }
  }
}
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.dropbox form {
  padding-top: 10px;
}

.dropbox-error {
  outline: 2px dashed white; /* the dash box */
  outline-offset: -10px;
  background: #b71c1c;
  color: white;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
